import { Phone, CheckCircle2 } from "lucide-react";
import { resolveImage } from "@/lib/api";

export default function About({ data, branding, onEnquire }) {
  return (
    <section id="about" data-testid="section-about" className="section-pad bg-[#FDFBF7]">
      <div className="container-pad grid lg:grid-cols-2 gap-12 md:gap-16 items-center">
        <div className="relative">
          <div className="aspect-[4/5] w-full rounded-3xl overflow-hidden shadow-xl bg-slate-100">
            <img src={resolveImage(data.image)} alt="About Sunbright" className="w-full h-full object-cover" />
          </div>
          <div className="absolute -bottom-6 -right-6 hidden md:block bg-[#1E3A8A] text-white rounded-2xl px-6 py-5 shadow-2xl">
            <div className="text-3xl font-extrabold text-teal-300">Estd. 2016</div>
            <div className="text-xs uppercase tracking-wider">Trusted Since</div>
          </div>
          <div className="absolute -top-4 -left-4 hidden md:block bg-teal-600 text-white rounded-2xl px-5 py-4 shadow-xl">
            <div className="text-xs uppercase tracking-wider">PCI Approved</div>
            <div className="text-sm font-semibold">Authorised Colleges</div>
          </div>
        </div>

        <div>
          <div className="kicker">{data.kicker || "About Us"}</div>
          <h2 className="heading-main mt-4">{data.title}</h2>
          <p className="heading-sub">{data.description}</p>

          <div className="mt-8 grid grid-cols-2 gap-4">
            {(data.stats || []).map((s, i) => (
              <div key={i} className="card-elev p-5">
                <div className="text-3xl font-extrabold text-[#1E3A8A]">{s.value}</div>
                <div className="text-xs uppercase tracking-wider text-slate-500 mt-1">{s.label}</div>
              </div>
            ))}
          </div>

          <ul className="mt-8 grid sm:grid-cols-2 gap-3">
            {["Expert mentors", "Hands-on labs", "Career counselling", "Admission support"].map((t) => (
              <li key={t} className="flex items-center gap-2 text-sm text-slate-700">
                <CheckCircle2 className="w-4 h-4 text-teal-600" /> {t}
              </li>
            ))}
          </ul>

          <div className="mt-9 flex flex-wrap gap-3">
            <button onClick={onEnquire} className="btn-primary" data-testid="about-enquire-btn">
              {data.ctaLabel || "Talk to Counsellor"}
            </button>
            <a href={`tel:${branding?.primaryPhone || ""}`} className="btn-ghost" data-testid="about-call-btn">
              <Phone className="w-4 h-4" /> {branding?.primaryPhone}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
